export class PesquisaAtendimentoForm {
  constructor(
    public atendimentoId: number,
    public hash: string,
    public resposta1: number,
    public resposta2: number
  ) {}
}
